import script from "./AnnouncementModalBodyParser.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementModalBodyParser.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementModalBodyParser.vue?vue&type=style&index=0&id=dd2525ba&lang=scss&scoped=true"
script.__scopeId = "data-v-dd2525ba"

export default script